var src,
  srcset,
  wnw_windowWidth,
  wnw_windowHeight,
  critical2,
  cls_css,
  lazyBackground,
  lazyIframe,
  lazybg,
  s,
  i,
  flag = 1,
  external_single_loaded = 1;
function wnw_init() {
  ((cls_css = document.querySelectorAll(".cls_css")).forEach(function (e) {
    e.remove();
  }),
    lazyLoadCss(),
    lazyLoadStyle(),
    lazyLoadImg(),
    lazyLoadBackground(),
    lazyLoadVideo(),
    lazyLoadIframe(),
    lazyLoadPoster(),
    flag && ((flag = 0), load_all_js()));
}
function insertAfter(e, t) {
  t.parentNode.insertBefore(e, t.nextSibling);
}
function lazyLoadImg() {
  var e = document.querySelectorAll("img.lazy2");
  for (i = 0; i < e.length; i++)
    ((src =
      wnw_windowWidth < 600
        ? void 0 === e[i].dataset.mobsrc
          ? e[i].dataset.src
          : e[i].dataset.mobsrc
        : void 0 === e[i].dataset.src
          ? e[i].src
          : e[i].dataset.src),
      (srcset = e[i].getAttribute("data-srcset")
        ? e[i].getAttribute("data-srcset")
        : ""),
      null != src && "" != src && (e[i].src = src),
      null != srcset && "" != srcset && (e[i].srcset = srcset),
      e[i].classList.remove("lazy2"));
}
function lazyLoadImg2() {
  var e = document.querySelectorAll("img.lazy3");
  for (i = 0; i < e.length; i++) {
    var t = e[i].getBoundingClientRect();
    0 != t.top &&
      t.top - wnw_windowHeight < 1 &&
      ((src =
        wnw_windowWidth < 600
          ? void 0 === e[i].dataset.mobsrc
            ? e[i].dataset.src
            : e[i].dataset.mobsrc
          : void 0 === e[i].dataset.src
            ? e[i].src
            : e[i].dataset.src),
      (srcset = e[i].getAttribute("data-srcset")
        ? e[i].getAttribute("data-srcset")
        : ""),
      null != src && "" != src && (e[i].src = src),
      null != srcset && "" != srcset && (e[i].srcset = srcset),
      e[i].classList.remove("lazy3"));
  }
}
function lazyLoadBackground() {
  (lazyBackground = document.querySelectorAll(".lazybg")).forEach(function (e) {
    (null !=
      (lazybg =
        wnw_windowWidth < 600
          ? void 0 === e.dataset.mobstyle
            ? e.dataset.style
            : e.dataset.mobstyle
          : void 0 === e.dataset.style
            ? e.style
            : e.dataset.style) &&
      "" != lazybg &&
      (e.style = lazybg),
      e.classList.remove("lazybg"));
  });
}
function lazyLoadBackground2() {
  (lazyBackground = document.querySelectorAll(".lazybg2")).forEach(
    function (e) {
      var t = e.getBoundingClientRect();
      0 != t.top &&
        t.top - wnw_windowHeight < 100 &&
        (null !=
          (lazybg =
            wnw_windowWidth < 600
              ? void 0 === e.dataset.mobstyle
                ? e.dataset.style
                : e.dataset.mobstyle
              : void 0 === e.dataset.style
                ? e.style
                : e.dataset.style) &&
          "" != lazybg &&
          (e.style = lazybg),
        e.classList.remove("lazybg2"));
    },
  );
}
function lazyLoadCss() {
  var e = document.querySelectorAll("link[data-href]");
  for (i = 0; i < e.length; i++) {
    var t = document.createElement("link");
    ((t.href = e[i].getAttribute("data-href")),
      (t.rel = "stylesheet"),
      e[i].parentNode.insertBefore(t, e[i]),
      delete e[i].dataset.href,
      e[i].parentNode.removeChild(e[i]));
  }
}
function lazyLoadStyle() {
  var e = document.querySelectorAll("style[type=lazyload2]");
  for (i = 0; i < e.length; i++) {
    var t = document.createElement("style");
    ((t.innerHTML = e[i].innerHTML),
      e[i].parentNode.insertBefore(t, e[i]),
      e[i].parentNode.removeChild(e[i]));
  }
}
function lazyLoadVideo() {
  ((lazyVideo = document.querySelectorAll("video")),
    lazyVideo.forEach(function (e) {
      null != e.dataset.src &&
        "" != e.dataset.src &&
        ((e.src = e.dataset.src),
        e.load(),
        (e.muted = !0),
        e.play(),
        delete e.dataset.src);
    }));
}
function lazyLoadIframe() {
  (lazyIframe = document.querySelectorAll("iframe")).forEach(function (e) {
    null != e.dataset.src &&
      "" != e.dataset.src &&
      ((e.src = e.dataset.src), delete e.dataset.src);
  });
}
function lazyLoadPoster() {
  document.querySelectorAll("video[data-poster]").forEach(function (e) {
    null != e.dataset.poster &&
      "" != e.dataset.poster &&
      ((e.poster = e.dataset.poster), delete e.dataset.poster);
  });
}
function w3_load_js_uri(e) {
  var t = document.createElement("script");
  if (void 0 !== e.attributes)
    for (var n, a = 0, o = e.attributes, i = o.length; a < i; a++)
      ("data-type" == (n = o[a]).nodeName &&
        t.setAttribute("type", n.nodeValue),
        "data-src" != n.nodeName &&
          "type" != n.nodeName &&
          t.setAttribute(n.nodeName, n.nodeValue));
  return (
    (t.src = e.getAttribute("data-src")),
    insertAfter(t, e),
    delete e.dataset.src,
    delete e.type,
    e.parentNode.removeChild(e),
    t
  );
}
function w3_load_inline_js_single(e) {
  if (!external_single_loaded)
    return (
      setTimeout(function () {
        w3_load_inline_js_single(e);
      }, 100),
      !1
    );
  s = document.createElement("script");
  for (var t = 0; t < e.attributes.length; t++) {
    var n = e.attributes[t];
    ("data-type" == n.name && s.setAttribute("type", n.value),
      "type" != n.name && s.setAttribute(n.name, n.value));
  }
  ((s.innerHTML = e.innerHTML), insertAfter(s, e), e.parentNode.removeChild(e));
}
function lazyLoadScripts() {
  var e = document.querySelectorAll("script[type=lazyload2]");
  if (e.length < 1)
    return (document.body.classList.add("wnw_loaded"), void fullJSLoadedCB());
  if (null !== e[0].getAttribute("data-src")) {
    var t = w3_load_js_uri(e[0]);
    ((t.onload = function () {
      lazyLoadScripts();
    }),
      (t.onerror = function () {
        lazyLoadScripts();
      }));
  } else (w3_load_inline_js_single(e[0]), lazyLoadScripts());
}
function load_all_js() {
  lazyLoadScripts();
  setTimeout(function () {
    document.querySelectorAll(".critical2").forEach(function (element) {
      element.remove();
    });
  }, 8000);
  setInterval(function () {
    lazyLoadImg();
    lazyLoadIframe();
  });
}
function fullJSLoadedCB() {
  setTimeout(function () {});
}
document.addEventListener("DOMContentLoaded", function () {
  ((wnw_windowWidth = screen.width),
    (wnw_windowHeight = screen.height),
    lazyLoadImg2(),
    lazyLoadBackground2(),
    window.addEventListener("scroll", function () {
      wnw_init();
    }),
    window.addEventListener("mousemove", function () {
      wnw_init();
    }),
    window.addEventListener("touchstart", function () {
      wnw_init();
    }),
    setTimeout(function () {
      wnw_init();
    }, 8e3));
});
